<template>
	<NuxtLayout>
		<TextHeader />

		<section class="blog__ListWrapper container">
			<div class="blog__List">
				<NuxtLink :to="item.sef" class="blog__ListItem" v-for="item in data.results" :key="item.id">
					<Flare v-if="item.image" :srcset="item.image" size="both" width="550" height="680" crop="fill" :alt="item.image" />
					<h3 v-text="item.title" />
					<time :datetime="item.blog_date" v-text="formatDate(item.blog_date, 'PPP')" />
					<p v-text="item.description" />
				</NuxtLink>
			</div>
		</section>
	</NuxtLayout>
</template>

<script setup>
	defineProps({
		page: {},
	});

	const { data } = await usePaginatedData({
		endpoint: 'blog',
		fields: ['blog_date'],
	});
</script>

<style lang="scss">
	@import url('@/assets/styles/pages/_blogList.scss');
</style>
